<template>
  <info-layout>
    <router-view />
  </info-layout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import InfoLayout from '@/views/Layouts/InfoLayout.vue'

export default defineComponent({
  name: 'InfoPage',
  components: {
    InfoLayout,
  },
})
</script>
